import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c9f20f54"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "button-inner-container" }
const _hoisted_2 = { class: "watermark" }
const _hoisted_3 = { class: "contents" }
const _hoisted_4 = { class: "button-icon" }
const _hoisted_5 = { class: "button-text-container" }
const _hoisted_6 = { class: "button-text" }

import { computed } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'home-page-button',
  props: {
  /**
   * The text content to be displayed.
   * @type {string}
   * @required
   */
  text: {
    type: String,
    required: true,
  },

  /**
   * The background color for the component.
   * @type {string}
   * @required
   */
  backColor: {
    type: String,
    required: true,
  },

  /**
   * The color of the watermark.
   * @type {string}
   * @required
   */
  watermarkColor: {
    type: String,
    required: true,
  },

  /**
   * The width of the icon displayed in the component.
   * @type {string}
   * @default '80px'
   */
  iconWidth: {
    type: String,
    default: "80px",
  },

  /**
   * The width of the watermark.
   * @type {string}
   * @default '200px'
   */
  watermarkWidth: {
    type: String,
    default: "200px",
  },
},
  emits: ["click"],
  setup(__props, { emit }) {

const props = __props;

_useCssVars(_ctx => ({
  "3e9e61cf": (__props.backColor),
  "78fdba2c": (__props.watermarkColor),
  "7a14b88f": (__props.watermarkWidth),
  "c57fd840": (__props.iconWidth),
  "57db3daf": (textRightPadding.value)
}))





const onClick = () => emit("click");

const textRightPadding = computed(() =>
  props.text.length < 10 ? "30px" : "0px",
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "button-outer-container",
    onClick: onClick
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _renderSlot(_ctx.$slots, "icon")
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _renderSlot(_ctx.$slots, "icon")
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("span", _hoisted_6, _toDisplayString(__props.text), 1)
      ])
    ])
  ]))
}
}

})